import { useEffect } from "react";

const isEditable = (el) => !!el?.closest?.("input, textarea, [contenteditable='true'], [data-allow-copy]");

export function useCopyProtection(pathname) {
  useEffect(() => {
    const exempt = pathname.startsWith("/admin");
    document.body.classList.toggle("no-copy", !exempt);
    if (exempt) return;
    const block = (e) => { if (!isEditable(e.target)) e.preventDefault(); };
    const onKey = (e) => {
      if (isEditable(e.target)) return;
      const k = e.key?.toLowerCase();
      if ((e.ctrlKey || e.metaKey) && ["c", "x", "u", "s", "a", "p"].includes(k)) e.preventDefault();
      if (e.key === "F12" || ((e.ctrlKey || e.metaKey) && e.shiftKey && ["i", "j", "c"].includes(k))) e.preventDefault();
    };
    document.addEventListener("contextmenu", block);
    document.addEventListener("copy", block);
    document.addEventListener("cut", block);
    document.addEventListener("dragstart", block);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("contextmenu", block);
      document.removeEventListener("copy", block);
      document.removeEventListener("cut", block);
      document.removeEventListener("dragstart", block);
      document.removeEventListener("keydown", onKey);
    };
  }, [pathname]);
}
